import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useHistory, useParams } from 'react-router-dom';
import { Box, Breadcrumbs, Link, Typography, Paper, Tooltip, CircularProgress } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { CustomButton } from '../../../../components/CustomButton';
import { ReactComponent as EditIcon } from '../../../../assets/images/edit.svg';
import { ReactComponent as BoxIconRed } from '../../../../assets/images/box-red.svg';
import { ReactComponent as BoxIconGrey } from '../../../../assets/images/box-grey.svg';
import { ReactComponent as CopyIcon } from '../../../../assets/images/copyIcon.svg';
import { ReactComponent as ClockIcon } from '../../../../assets/images/clock.svg';
import { ReactComponent as SendIcon } from '../../../../assets/images/send.svg';
import { ReactComponent as RejectIcon } from '../../../../assets/images/reject.svg';
import { ReactComponent as ApproveIcon } from '../../../../assets/images/approve.svg';
import { DoubleField } from '../../../support/components/DoubleField';
import { ROUTES, getRouteWithParam, ROUTE_FOR_ASSETS } from '../../../../constants/routes';
import {
  getEventById,
  archivedCard,
  getCmsPackages,
  getSubscribersList,
  onApproveCard,
  approveCard
} from '../../../../store/bonuses/actions';
import { CircularProgressCenter } from '../../../../components/CircularProgressCenter';
import { formatDate } from '../../../../utils/formatDate';
import { CustomModal } from '../../../../components/CustomModal';
import { ENTITY } from '../../constants';
import { visibleBySectionPermission } from '../../../../utils/visibleBySectionPermission';
import { DISABLED_CONTROL_TOOLTIP, MAILING_TYPE, PERMISSIONS } from '../../../../constants/variables';
import { Tab } from '../../../../components/Tab';
import EnhancedTable from '../../../../components/EnhancedTable';
import { MAILING_HEAD_CELLS, SUBSCRIBERS_HEAD_CELLS } from '../../constants/headCell';
import { MailingTableBody } from '../../components/MailingTableBody';
import {
  createMailingForBonusCard,
  deleteMailingForBonusCard,
  getBonusCardMailingTemplates,
  getGroupedTemplates,
  getMailingTriggers
} from '../../../../store/mailing/actions';
import { getMailingColorStatus } from '../../../mailing/constants';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import axios from 'axios';
import { serviceLocalStorage } from '../../../../utils/serviceLocalStorage';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@mui/material';
import { setUsersPermissions } from '../../../../utils/setUsersPermissions';
import { SubscribersTableBody } from '../../components/SubscribersTableBody';
import { CustomExpand } from '../../../../components/CustomExpand';
import { ModalReason } from '../../components/ModalReason';
import { getAssetUrl } from '../../../../utils/getAssetUrl';

const BONUS_DETAIL_TAB = {
  DETAILING: 'Detailing',
  MAILING: 'Mailing',
  SUBSCRIBERS: 'SUBSCRIBERS'
};
const orderBy = (property) => {
  switch (property) {
    case 'mailing_trigger_id':
      return 'mailing_trigger';
    case 'mailing_template_id':
      return 'mailing_template';
    default:
      return property;
  }
};

export const DetailEvent = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { eventCard, cms, subscribersList, fetching: bonusesFetching } = useSelector((state) => state.bonuses);
  const { bonusCardTemplates, groupedTemplates, triggers, fetching: mailingFetching, error } = useSelector((state) => state.mailing);
  const { userPermissions, currentUsersPermissions } = useSelector((state) => state.userPermissions);
  const permissions = setUsersPermissions(userPermissions, currentUsersPermissions?.permissions);

  const [isSuccessModal, setIsSuccessModal] = useState(false);
  const [onApproveModal, setOnApproveModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [typeBonusTab, setTypeBonusTab] = useState(BONUS_DETAIL_TAB.DETAILING);
  const [updatedPackages, setUpdatedPackage] = useState(false);
  const [listDownloading, setListDownloading] = useState(false);
  const [downloadListError, setDownloadListError] = useState(null);

  const [mailingFilter, setMailingFilter] = useState({
    orderBy: 'mailing_type',   // mailing_type | mailing_trigger_id | mailing_template_id
    orderType: 'desc',
    page: 0,
    size: 10,
  });

  const [subscribersFilter, setSubscribersFilter] = useState({
    orderBy: 'created_at',
    orderType: 'desc',
    page: 0,
    size: 10,
  });

  const isArchivedStatus = eventCard.status === 'Архив' || eventCard.status === 'archive';
  const isActiveStatus = eventCard.status === 'Активна' || eventCard.status === 'active';
  const isForApprove = eventCard.status === 'Создана' || eventCard.status === 'Доработка';
  const isToApprove = eventCard.status === 'На одобрении' && visibleBySectionPermission(permissions, PERMISSIONS.BONUS.ApproveOrReject.value);
  const isDisabledArchiveBonusCards = !visibleBySectionPermission(permissions, PERMISSIONS.BONUS.ArchiveBonusCards.value);
  const isDisabledListHistory = !visibleBySectionPermission(permissions, PERMISSIONS.LOGGING.ListHistory.value);
  const isDisabledCopyBonusCard = !visibleBySectionPermission(permissions, PERMISSIONS.BONUS.CopyBonusCards.value);
  const isDisabledUpdateBonusCard = !visibleBySectionPermission(permissions, PERMISSIONS.BONUS.UpdateBonusCards.value);

  const downloadListOfSubscribers = () => {
    setListDownloading(true);
    setDownloadListError(null);

    return axios.get(
      `${process.env.REACT_APP_API_URL}/bonuses/card/${id}/mailing/upload-report`,
      {
        responseType: "json",
        headers: {
          Authorization: `Bearer ${serviceLocalStorage.getAccessToken()}`
        }
      }
    ).then((response) => {
      const instance = response.data?.instance || response.data?.data?.instance;

      setListDownloading(false);
      if (response.status !== 200) {
        setDownloadListError(response.statusText);
        return;
      }
      if (!instance) {
        setDownloadListError('Нет данных для выгрузки');
        return;
      }
      const link = document.createElement('a');
      link.href = process.env.REACT_APP_API_URL.replace('/api', instance);
      link.setAttribute('download',  instance.replace('/bonuses/static/private/', ''));
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    })
      .catch((error) => {
        setListDownloading(false);
        error.json().then((json) => {
          setDownloadListError(json);
        });

      }).finally(() =>
        setTimeout(() => setDownloadListError(null), 2000)
      );
  };

  useEffect(() => {
    dispatch(getEventById(id));
    dispatch(getGroupedTemplates());
    dispatch(getMailingTriggers());
    if (!cms?.length) dispatch(getCmsPackages());
  }, // eslint-disable-next-line
    []);

  useEffect(() => {
    eventCard?.trigger?.slug === 'retention' && dispatch(getSubscribersList(
      eventCard?.id,
      {
        page: subscribersFilter.page + 1,
        order_type: subscribersFilter.orderType,
        order_by: orderBy(subscribersFilter.orderBy),
        size: subscribersFilter.size,
      }
      ))  // eslint-disable-next-line
  }, [
    eventCard?.id,
    subscribersFilter.orderType,
    subscribersFilter.orderBy,
    subscribersFilter.size,
    subscribersFilter.page,
  ])

  useEffect(() => {
    dispatch(getBonusCardMailingTemplates(
      id,
      {
        page: mailingFilter.page + 1,
        order_type: mailingFilter.orderType,
        order_by: orderBy(mailingFilter.orderBy),
        size: mailingFilter.size,
      },
    )); // eslint-disable-next-line
  }, [
    mailingFilter.orderType,
    mailingFilter.orderBy,
    mailingFilter.size,
    mailingFilter.page,
  ]);

  const redirectToBonuses = () => history.push(ROUTES.BONUSES);

  const handleArchiver = () => {
    dispatch(archivedCard(id, redirectToBonuses));
    setIsSuccessModal(false);
  };

  const handleOnApprove = () => {
    dispatch(onApproveCard(id));
    setOnApproveModal(false);
  };

  const handleApprove = () => {
    dispatch(approveCard(id, { status: 'Одобрена' }));
    setApproveModal(false);
  };

  const handleReject = (reason) => {
    dispatch(approveCard(id, { status: 'Доработка', reason }));
    setRejectModal(false);
  }

  const isShowAllEntity = () => {
    if (typeof eventCard?.to_all_customer !== 'boolean') {
      return true;
    }

    return eventCard?.to_all_customer;
  };

  const isCardArchived = eventCard.status === 'archive' || eventCard.status === 'Архив';
  const isCardArchivedOrActive = isCardArchived || eventCard.status === 'active' || eventCard.status === 'Активна';

  const mailingTemplatesOptions = [];
  Object.keys(groupedTemplates).forEach((mailingType) => {
    groupedTemplates[mailingType]?.forEach((template) => {
      mailingTemplatesOptions.push({
        label: template.name, value: template.id, mailingType, text: template.text,
      })
    });
  });
  const mailingTriggersOptions = triggers?.map((trigger) => ({ label: trigger.name, value: trigger.id })) || [];
  const mailingTypes = Object.keys(MAILING_TYPE).map((key) => ({ label: MAILING_TYPE[key], value: key.toLowerCase() }));
  const isActiveCard = eventCard.status === 'active' || eventCard.status === 'Активна';

  const addRow = ({ triggerId, templateId }) => {
    const payload = {
      mailing_template_id: templateId,
      mailing_trigger_id: triggerId,
    };
    dispatch(createMailingForBonusCard(id, payload, isActiveCard || eventCard.status === 'Одобрена'));
  };

  const deleteRow = (mailingId) => {
    dispatch(deleteMailingForBonusCard(id, mailingId, isActiveCard));
  };

  const isPageVisible =
    visibleBySectionPermission(permissions, [PERMISSIONS.BONUS.ListBonusCards.value, PERMISSIONS.BONUS.CreateBonusCards.value], 'or') &&
    visibleBySectionPermission(permissions, PERMISSIONS.BONUS.RetrieveBonusCards.value);
  const isAllowedToUploadCustomerMailing = visibleBySectionPermission(permissions, PERMISSIONS.MAILING.UploadCustomerMailing.value);

  if (!isPageVisible) {
    return <></>;
  }

  if (eventCard?.id?.toString() !== id || !Object.values(eventCard).length) {
    return <CircularProgressCenter data-testid="CircularProgressCenter"/>;
  }

  return (
    <>
      <Box>
        <Breadcrumbs mb="24px" aria-label="breadcrumb">
          <Link component={RouterLink} underline="hover" color="inherit" to={ROUTES.BONUSES}>
            Бонусы
          </Link>

          <Typography sx={{ lineBreak: 'anywhere' }}>{eventCard.service.name}</Typography>
        </Breadcrumbs>

        <Paper sx={{ padding: '32px' }}>
          <Box display="flex" mb="16px" justifyContent="space-between" alignItems="center">
            <Box>
              <Typography color="text.secondary" sx={{ fontSize: '18px' }}>{eventCard.id}</Typography>
              <Typography variant="h1" mb="8px" mt="8px" sx={{ color: 'text.primary', lineBreak: 'auto', width: '90%' }} component="h1">
                {eventCard.service.name}
              </Typography>
              <Box>{eventCard.service.company.name}</Box>
            </Box>
            <Box data-testid="CurrentStatus" color={`${getMailingColorStatus(eventCard.status)}`}>{eventCard.status === 'archive' ? 'Архив' : eventCard.status}</Box>
          </Box>

          <CustomButton
            color="secondary"
            variant="outlined"
            size="small"
            sx={{ marginRight: '16px', display: isCardArchived ? 'none' : undefined, marginBottom: '16px' }}
            startIcon={<EditIcon />}
            component={RouterLink}
            to={getRouteWithParam(ROUTES.BONUSES_ADD_EVENT, ':id', id)}
            disabled={isDisabledUpdateBonusCard || isActiveStatus && isShowAllEntity() && eventCard.trigger.slug !== 'retention'}
            tooltip={isDisabledUpdateBonusCard && !isCardArchived ? DISABLED_CONTROL_TOOLTIP : null}
            data-testid="EditBonus"
          >
            Редактировать
          </CustomButton>

          <CustomButton
            color="secondary"
            variant="outlined"
            size="small"
            sx={{ marginRight: '16px', marginBottom: '16px' }}
            startIcon={<CopyIcon />}
            component={RouterLink}
            to={getRouteWithParam(ROUTES.BONUSES_COPY_EVENT, ':id', id)}
            disabled={isDisabledCopyBonusCard}
            tooltip={isDisabledCopyBonusCard ? DISABLED_CONTROL_TOOLTIP : null}
            data-testid="CopyBonus"
          >
            Копировать
          </CustomButton>

          <CustomButton
            color="secondary"
            variant="outlined"
            size="small"
            sx={{ marginRight: '16px', marginBottom: '16px' }}
            startIcon={<ClockIcon />}
            component={RouterLink}
            to={getRouteWithParam(ROUTES.BONUSES_EVENTS_HISTORY, ':id', id)}
            data-testid="History"
            disabled={isDisabledListHistory}
            tooltip={isDisabledListHistory ? DISABLED_CONTROL_TOOLTIP : null}
          >
            История событий
          </CustomButton>

          <CustomButton
            color="success"
            variant="outlined"
            size="small"
            sx={{ marginRight: '16px', display: !isForApprove ? 'none' : undefined, marginBottom: '16px' }}
            startIcon={<SendIcon />}
            onClick={() => setOnApproveModal(true)}
            data-testid="OnApprove"
          >
            Отправить на одобрение
          </CustomButton>

          <CustomButton
            color="success"
            variant="outlined"
            size="small"
            sx={{ marginRight: '16px', display: !isToApprove ? 'none' : undefined, marginBottom: '16px' }}
            startIcon={<ApproveIcon />}
            onClick={() => setApproveModal(true)}
            data-testid="Approve"
          >
            Одобрить кампанию
          </CustomButton>

          <CustomButton
            color="error"
            variant="outlined"
            size="small"
            sx={{ marginRight: '16px', display: !isToApprove ? 'none' : undefined, marginBottom: '16px' }}
            startIcon={<RejectIcon />}
            onClick={() => setRejectModal(true)}
            data-testid="Reject"
          >
            Отклонить кампанию
          </CustomButton>


          <CustomButton
            color="error"
            variant="outlined"
            size="small"
            sx={{ marginRight: '16px', display: isCardArchived ? 'none' : undefined, marginBottom: '16px' }}
            startIcon={<BoxIconRed />}
            onClick={() => setIsSuccessModal(true)}
            disabled={isDisabledArchiveBonusCards}
            tooltip={isDisabledArchiveBonusCards && !isArchivedStatus ? DISABLED_CONTROL_TOOLTIP : null}
            data-testid="ArchiveBonus"
          >
            В архив
          </CustomButton>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'left',
              flexWrap: 'wrap',
              gap: '20px',
              marginTop: '8px'
            }}>
            <DoubleField
              title="Дата старта"
              description={formatDate(eventCard.date_start, false)}
              data-testid="StartDate"
            />
            <DoubleField
              title="Дата окончания"
              description={`до ${formatDate(eventCard.date_end, true)}`}
              data-testid="EndDate"
            />

            <DoubleField
              title="Триггер"
              description={eventCard.trigger.name}
              data-testid="Trigger"
              sx={{ maxWidth: 200 }}
            />

            {eventCard.package && (
              <Box data-testid="Package">
                <Typography sx={{ color: 'text.secondary', minWidth: 180 }}>Пакет</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'left', gap: '10px' }}>
                  <Typography sx={{ fontWeight: 500, fontSize: '20px' }}>{eventCard.package.name}</Typography>
                  {
                    !isCardArchived && (
                      <Tooltip title="Обновить данные" placement="top">
                        <RestartAltIcon
                          onClick={() => dispatch(getCmsPackages({ update: true })).then(res => res.status === 200 && setUpdatedPackage(true))}
                          sx={{
                            color: updatedPackages ? 'success.main' : 'text.primary',
                            cursor: 'pointer'
                          }}
                          data-testid="RestartAltIcon"
                        />
                      </Tooltip>
                    )
                  }
                </Box>
              </Box>
            )}

            {eventCard.trigger.slug !== 'retention' ?
              isShowAllEntity() ? (
                <DoubleField title="Начислить абонентам" description={ENTITY[0].label} data-testid="ToAll"/>
              ) : (
                <Box data-testid="Attachments">
                  <Typography sx={{ color: 'text.secondary', minWidth: 180 }}>Начислить абонентам</Typography>
                  <CustomExpand
                    items={eventCard.customer_files}
                    node={file =>
                      <Typography key={file.id}>
                        <Link
                          variant="body"
                          href={`${ROUTE_FOR_ASSETS}${file.file_url}`}
                          color="primary.main"
                          underline="hover"
                          sx={{ fontWeight: 500, fontSize: '20px' }}
                        >
                          {file.file_name}
                        </Link>
                      </Typography>
                    }
                  />
                </Box>
              ) : null
            }

            {(eventCard.trigger.slug === 'welcome' && eventCard.cities.length) ? (
              <Box data-testid="City">
                <Typography sx={{ color: 'text.secondary', minWidth: 180 }}>Города</Typography>
                <CustomExpand items={eventCard?.cities}/>
              </Box>
              ) : null}
              {(eventCard.trigger.slug === 'welcome' && eventCard.universal_promocode) ? (
              <Box data-testid="UniversalPromocode">
                 <DoubleField
                  title="Единый промокод"
                  description={eventCard.universal_promocode}
                  data-testid="UniversalPromocode"
                />
              </Box>
              ) : null}
            {(eventCard.trigger.slug === 'welcome' && eventCard.site_url) ? (
              <Box data-testid="SiteUrl">
                 <DoubleField
                  title="Ссылка для перехода"
                  description={eventCard.site_url}
                  data-testid="SiteUrl"
                />
              </Box>
              ) : null}
          </Box>
        </Paper>

        <Box display="flex" justifyContent="space-between" data-testid='Tabs'>
          <Box display="flex">
            <Tab
              label="Детализация"
              setTypeTable={() => setTypeBonusTab(BONUS_DETAIL_TAB.DETAILING)}
              typeCurrent={typeBonusTab}
              typeDefault={BONUS_DETAIL_TAB.DETAILING}
            />
            {eventCard.trigger.slug === 'retention' &&
              <Tab
                label="Списки абонентов"
                setTypeTable={() => setTypeBonusTab(BONUS_DETAIL_TAB.SUBSCRIBERS)}
                typeCurrent={typeBonusTab}
                typeDefault={BONUS_DETAIL_TAB.SUBSCRIBERS}
              />
            }
            <Tab
              label="СМС/Email рассылка"
              setTypeTable={() => setTypeBonusTab(BONUS_DETAIL_TAB.MAILING)}
              typeCurrent={typeBonusTab}
              typeDefault={BONUS_DETAIL_TAB.MAILING}
            />
          </Box>
          {
            typeBonusTab === BONUS_DETAIL_TAB.MAILING && (
              <Box display="flex" justifyContent="center" flexDirection="column" data-testid="downloadListOfSubscribers">
                {
                  isAllowedToUploadCustomerMailing ? (
                    <CustomButton
                      onClick={() => downloadListOfSubscribers()}
                      variant="outlined"
                      size="small"
                      sx={{ width: '310px' }}
                      disabled={!isCardArchivedOrActive || listDownloading}
                    >
                      Выгрузка списка абонентов
                      {
                        listDownloading && (
                          <Box display="flex" alignItems="center" ml={2} sx={{ zoom: '.625' }}>
                            <CircularProgress />
                          </Box>
                        )
                      }
                    </CustomButton>
                  ) : (
                    <CustomButton
                      variant="outlined"
                      size="small"
                      sx={{ width: '310px' }}
                      disabled={true}
                      tooltip={DISABLED_CONTROL_TOOLTIP}
                    >
                      Выгрузка списка абонентов
                    </CustomButton>
                  )
                }
              </Box>
            )
          }
        </Box>

        {
          typeBonusTab === BONUS_DETAIL_TAB.DETAILING  && (
            <Paper
              sx={{
                padding: '32px',
                marginTop: '16px',
                display: 'grid',
                gridTemplateColumns: '2.5fr 1fr',
                gap: '24px'
              }}>
              <Box>
                {/* Temporary not showing, Task=382736 */}

                {/*{ eventCard.trigger.slug === 'active' && eventCard.packages_validation && (*/}
                {/*  <DoubleField*/}
                {/*    display="flex"*/}
                {/*    mb={3}*/}
                {/*    sx={{ 'p:first-child': { maxWidth: '190px', marginRight: '24px' } }}*/}
                {/*    title="Проверка совместимости бонусов"*/}
                {/*    description={eventCard.packages_validation[0]}*/}
                {/*  />*/}
                {/*)}*/}

                {/*{ eventCard.trigger.slug === 'active' && eventCard.activation_conditions && (*/}
                {/*  <DoubleField*/}
                {/*    display="flex"*/}
                {/*    mb={3}*/}
                {/*    sx={{ 'p:first-child': { maxWidth: '190px', marginRight: '24px' } }}*/}
                {/*    title="Условия активации бонусов"*/}
                {/*    description={eventCard.activation_conditions[0]}*/}
                {/*  />*/}
                {/*)}*/}

                {eventCard.add_if_debt_exist && (
                  <DoubleField
                    display="flex"
                    mb={3}
                    sx={{ 'p:first-child': { marginRight: '34px' } }}
                    title="Тип бонуса"
                    description="Начисление"
                  />
                )}

                <DoubleField
                  display="flex"
                  mb={3}
                  sx={{ 'p:first-child': { maxWidth: '190px', marginRight: '24px' } }}
                  title="Срок действия бонусов со дня начисления"
                  description={`до ${formatDate(eventCard.date_expiry, true)}`}
                />

                <DoubleField
                  display="flex"
                  mb={3}
                  sx={{ 'p:first-child': { marginRight: '34px' }, lineBreak: 'auto' }}
                  title="Условия"
                  description={eventCard.terms}
                />

                <DoubleField
                  display="flex"
                  sx={{ 'p:first-child': { marginRight: '34px' } }}
                  title="Количество бонусов"
                  description={eventCard.bonus_add}
                />

                {eventCard.customers_limit ?
                  <DoubleField
                    display="flex"
                    sx={{ 'p:first-child': { marginRight: '34px' } }}
                    title="Количество абонентов"
                    description={eventCard.customers_limit}
                    mt={3}
                  /> : null
                }
              </Box>
              {eventCard.package && (
                <Box>
                  <Typography sx={{ color: 'text.primary', fontWeight: '500' }}>Баннер</Typography>
                  <Box mt="16px">
                    <Box
                      component="img"
                      alt="Баннер пакета"
                      src={getAssetUrl(cms?.find(item => item?.id === eventCard?.package?.id)?.image)}
                      sx={{
                        borderRadius: '8px',
                        width: '240px',
                        height: '240px'
                      }}
                      data-testid="Banner"
                    />
                  </Box>
                </Box>
              )}
            </Paper>
          )
        }

        {
          typeBonusTab === BONUS_DETAIL_TAB.MAILING && (
            <Paper
              sx={{
                padding: '32px',
                marginTop: '16px',
              }}
            >
              <EnhancedTable
                rows={bonusCardTemplates || []}
                headCells={MAILING_HEAD_CELLS}
                total={bonusCardTemplates?.length || 0}
                fetching={mailingFetching}
                heightRow={109}
                filter={mailingFilter}
                setFilter={setMailingFilter}
                rowsPerPage={[5, 10, 20]}
                showPagination={false}
              >
                <MailingTableBody
                  data={bonusCardTemplates}
                  templates={mailingTemplatesOptions}
                  triggers={mailingTriggersOptions}
                  mailingTypes={mailingTypes}
                  addRow={addRow}
                  deleteRow={deleteRow}
                  isEditable={false}
                  isArchivedStatus={isArchivedStatus}
                  isActiveStatus={isActiveStatus}
                  permissions={permissions}
                />
              </EnhancedTable>
              {
                error && (
                  <Box color="error.main" fontSize="1rem" textAlign="center" data-testid="ErrorBlock">
                    {error}
                  </Box>
                )
              }
            </Paper>
          )
        }

        {
          typeBonusTab === BONUS_DETAIL_TAB.SUBSCRIBERS && (
            bonusesFetching || subscribersList?.items?.length ? (
              <EnhancedTable
                rows={subscribersList.items || []}
                headCells={SUBSCRIBERS_HEAD_CELLS}
                total={subscribersList.total}
                fetching={bonusesFetching}
                heightRow={109}
                filter={subscribersFilter}
                setFilter={setSubscribersFilter}
              >
                <SubscribersTableBody data={subscribersList.items} link={'/bonuses/card/file/'}/>
              </EnhancedTable>
            ) : (
              <Box display="flex" justifyContent="center" alignItems="center" height="70vh" data-testid="NotFound">
                <Box display="flex" flexDirection="column" alignItems="center">
                  <BoxIconGrey width="76px" />

                  <Typography mt="28px" variant="h1" sx={{ color: 'text.primary', fontSize: 26, fontWeight: 600 }} component="h2">
                    Списки абонентов не найдены
                  </Typography>
                </Box>
              </Box>
            )
          )
        }
      </Box>

      <CustomModal
        opened={isSuccessModal}
        modalClose={() => setIsSuccessModal(false)}
        modalSubmit={handleArchiver}
        text="Вы действительно хотите перевести данное событие по начислению бонусов в Архив?"
        cancelBtnName="Отмена"
        submitBtnName="Да"
        data-testid="WarningModal"
      />

      <CustomModal
        opened={onApproveModal}
        modalClose={() => setOnApproveModal(false)}
        modalSubmit={handleOnApprove}
        text="Вы действительно хотите отправить данное событие на одобрение?"
        cancelBtnName="Отмена"
        submitBtnName="Да"
      />

      <CustomModal
        opened={approveModal}
        modalClose={() => setApproveModal(false)}
        modalSubmit={handleApprove}
        text="Вы действительно хотите одобрить данное событие?"
        cancelBtnName="Отмена"
        submitBtnName="Да"
      />

      <ModalReason showModal={rejectModal} setShowModal={setRejectModal} submit={handleReject}/>

      <Snackbar
        open={!!downloadListError}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        data-testid="SnackBar"
      >
        <Alert
          severity="error"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '220px',
            height: 'auto'
          }}>
          {downloadListError}
        </Alert>
      </Snackbar>
  </>
  );
};
